var map = {
	"./Accelerator Rifle.webp": 6544,
	"./Acclimated.webp": 6274,
	"./Adjudicator.webp": 737,
	"./Adreno-Defibrillator.webp": 3192,
	"./Advanced Filtration.webp": 3693,
	"./Airburst Rocket Launcher.svg": 4643,
	"./Amendment.webp": 3658,
	"./Anti-Materiel Rifle.svg": 1047,
	"./Anti-Personnel Minefield.svg": 2037,
	"./Anti-Tank Emplacement.svg": 6697,
	"./Anti-Tank Mines.svg": 6494,
	"./Arc Thrower.svg": 2914,
	"./Arc.webp": 2641,
	"./Autocannon Sentry.svg": 9180,
	"./Autocannon.svg": 5283,
	"./Ballistic Padding.webp": 483,
	"./Ballistic Shield Backpack.svg": 6637,
	"./Bastion.svg": 1511,
	"./Belt-fed GL.svg": 4773,
	"./Blitzer.webp": 8437,
	"./Breaching Hammer.svg": 4304,
	"./Breaker Incendiary.webp": 3181,
	"./Breaker Spray&Pray.webp": 8674,
	"./Breaker.webp": 9325,
	"./Breakthrough.svg": 6553,
	"./Bullet Storm.svg": 7138,
	"./Bushwacker.webp": 2932,
	"./C4 Pack.svg": 5387,
	"./Censor.webp": 9633,
	"./Combat Hatchet.webp": 1508,
	"./Commando.svg": 2323,
	"./Concussive Padding, Grenadier.svg": 5673,
	"./Concussive Padding, Hazmat.svg": 5383,
	"./Concussive Padding, Reinforced.svg": 3811,
	"./Constitution.webp": 8324,
	"./Cookout.webp": 9405,
	"./Coyote.webp": 514,
	"./Cremator.svg": 7068,
	"./Crisper.webp": 8141,
	"./Dagger.webp": 6065,
	"./De-Escalator.svg": 9015,
	"./Deadeye.webp": 1598,
	"./Defender.webp": 3748,
	"./Defoliation Tool.svg": 1519,
	"./Democracy Protects.webp": 4948,
	"./Desert Stormer.webp": 8364,
	"./Diligence Counter Sniper.webp": 2922,
	"./Diligence.webp": 8763,
	"./Directional Shield.svg": 9130,
	"./Dominator.webp": 218,
	"./Double Edge Sickle.webp": 3720,
	"./Double Freedom.webp": 172,
	"./Dynamite.webp": 7952,
	"./EMS Mortar Sentry.svg": 5458,
	"./Eagle 110mm Rocket Pods.svg": 4011,
	"./Eagle 500KG Bomb.svg": 2468,
	"./Eagle Airstrike.svg": 5933,
	"./Eagle Cluster Bomb.svg": 7231,
	"./Eagle Napalm Airstrike.svg": 8160,
	"./Eagle Rearm.svg": 5308,
	"./Eagle Smoke Strike.svg": 7082,
	"./Eagle Strafing Run.svg": 8562,
	"./Electrical Conduit.webp": 9303,
	"./Emancipator Exosuit.svg": 475,
	"./Engineering Kit.webp": 1550,
	"./Entrenchment Tool.webp": 4687,
	"./Epoch.svg": 9700,
	"./Eruptor.webp": 390,
	"./Expendable Anti-Tank.svg": 9976,
	"./Expendable Napalm.svg": 7368,
	"./Exploding Crossbow.webp": 5917,
	"./Extra Padding.webp": 6834,
	"./Fast Recon Vehicle.svg": 3594,
	"./Feet First.webp": 4493,
	"./Flame Sentry.svg": 7555,
	"./Flamethrower.svg": 2655,
	"./Fortified.webp": 8101,
	"./Frag.webp": 2343,
	"./Gallant.webp": 6464,
	"./Gas Mines.svg": 3008,
	"./Gas Mortar.svg": 1327,
	"./Gas.webp": 1412,
	"./Gatling Sentry.svg": 1368,
	"./Giga Grenade.webp": 7013,
	"./Grenade Launcher.svg": 7411,
	"./Grenade Pistol.webp": 3542,
	"./Grenadier Battlement.svg": 846,
	"./Guard Dog Arc.svg": 1498,
	"./Guard Dog Breath.svg": 4396,
	"./Guard Dog Rover.svg": 5870,
	"./Guard Dog.svg": 7258,
	"./Gunslinger.webp": 6935,
	"./HMG Emplacement.svg": 4964,
	"./Halt.webp": 5680,
	"./Heavy Machine Gun.svg": 919,
	"./High Explosive.webp": 4100,
	"./Hot Dog.svg": 1192,
	"./Hover Pack.svg": 3912,
	"./Impact.webp": 2029,
	"./Incendiary Impact.webp": 5421,
	"./Incendiary Mines.svg": 4639,
	"./Incendiary.webp": 4221,
	"./Inflammable.webp": 5503,
	"./Integrated Explosives.webp": 2746,
	"./Jump Pack.svg": 8620,
	"./Knight.webp": 5842,
	"./Laser Cannon.svg": 9349,
	"./Laser Sentry.svg": 3147,
	"./Leveller.svg": 542,
	"./Liberator Carbine.webp": 9939,
	"./Liberator Concussive.webp": 8327,
	"./Liberator Penetrator.webp": 723,
	"./Liberator.webp": 4337,
	"./Loyalist.webp": 3956,
	"./Lumberer.svg": 7485,
	"./Lure Mine.webp": 7896,
	"./M6C.webp": 9241,
	"./M7S.webp": 636,
	"./M90A.webp": 4338,
	"./MA5C.webp": 9513,
	"./Machete.webp": 5670,
	"./Machine Gun Sentry.svg": 463,
	"./Machine Gun.svg": 3226,
	"./Maxigun.svg": 232,
	"./Med-Kit.webp": 9026,
	"./Missile Pistol.webp": 5808,
	"./Mortar Sentry.svg": 5827,
	"./One True Flag.svg": 8489,
	"./One Two.webp": 3395,
	"./Orbital 120MM HE Barrage.svg": 2654,
	"./Orbital 380MM HE Barrage.svg": 9054,
	"./Orbital Airburst Strike.svg": 9232,
	"./Orbital EMS Strike.svg": 2721,
	"./Orbital Gas Strike.svg": 4411,
	"./Orbital Gatling Barrage.svg": 3620,
	"./Orbital Laser.svg": 981,
	"./Orbital Napalm Barrage.svg": 11,
	"./Orbital Precision Strike.svg": 3902,
	"./Orbital Railcannon Strike.svg": 8555,
	"./Orbital Smoke Strike.svg": 9967,
	"./Orbital Walking Barrage.svg": 8461,
	"./Oxygenator.svg": 5413,
	"./Pacifier.webp": 8486,
	"./Patriot Exosuit.svg": 859,
	"./Peacemaker.webp": 6077,
	"./Peak Physique.webp": 240,
	"./Pineapple.webp": 7511,
	"./Portable Hellbomb.svg": 3325,
	"./Pummeler.webp": 3704,
	"./Punisher Plasma.webp": 1397,
	"./Punisher.webp": 6501,
	"./Purifier.webp": 7515,
	"./Pyrotech.webp": 4979,
	"./Quasar Cannon.svg": 1429,
	"./Railgun.svg": 273,
	"./Re-Educator.webp": 2268,
	"./Recoilless Rifle.svg": 4394,
	"./Redeemer.webp": 6756,
	"./Reduced Signature.webp": 2013,
	"./Reinforced Epaulettes.webp": 2228,
	"./Reprimand.webp": 815,
	"./Rock Solid.svg": 6583,
	"./Rock Solid.webp": 6293,
	"./Rocket Sentry.svg": 5262,
	"./Saber.webp": 2704,
	"./Scorcher.webp": 4480,
	"./Scout.webp": 7155,
	"./Scythe.webp": 4427,
	"./Seeker.webp": 6052,
	"./Senator.webp": 9235,
	"./Servo-Assisted.webp": 7421,
	"./Shield Generator Pack.svg": 1344,
	"./Shield Generator Relay.svg": 7054,
	"./Shield.webp": 2118,
	"./Sickle.webp": 1594,
	"./Siege-Ready.webp": 9440,
	"./Slugger.webp": 5569,
	"./Smoke.webp": 1228,
	"./Smokescreen.webp": 4296,
	"./Solo Silo.svg": 8259,
	"./Spear.svg": 9031,
	"./Speargun.svg": 970,
	"./StA-11.webp": 8380,
	"./StA-52.webp": 1829,
	"./Stalwart.svg": 1769,
	"./Sterilizer.svg": 5462,
	"./Stim Pistol.webp": 9709,
	"./Stoker.webp": 4573,
	"./Stun Batton.webp": 8721,
	"./Stun Lance.webp": 6420,
	"./Stun.webp": 1583,
	"./Supplementary Adrenaline.webp": 8189,
	"./Supply Pack.svg": 7479,
	"./Suppressor.webp": 8861,
	"./Sweeper.webp": 210,
	"./Talon.webp": 357,
	"./Tenderizer.webp": 2177,
	"./Tesla Tower.svg": 2693,
	"./Thermite.webp": 7725,
	"./Throwing Knife.webp": 5554,
	"./Torcher.webp": 2548,
	"./Trident.webp": 6305,
	"./Ultimatum.webp": 9163,
	"./Unflinching.webp": 9266,
	"./Urchin.webp": 3920,
	"./Variable.webp": 1951,
	"./Verdict.webp": 1588,
	"./Veto.webp": 2051,
	"./Warp Pack.svg": 4970,
	"./Warrant.webp": 8704,
	"./Wasp.svg": 8008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6929;